/**
 * Hook to determine nav visibility based on current route
 * Nav is hidden on workflow and timeline editor routes
 */

import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export type NavVisibility = "visible" | "hidden";

const HIDDEN_ROUTES = ["/workflows/", "/video-editor/"];

export function useNavVisibility(): NavVisibility {
  const location = useLocation();

  return useMemo(() => {
    const { pathname } = location;

    // Hide nav on workflow and timeline editor routes
    const shouldHide = HIDDEN_ROUTES.some((route) => pathname.includes(route));

    return shouldHide ? "hidden" : "visible";
  }, [location.pathname]);
}
